import { useState, useEffect } from 'react';

export default function RepeaterEditor({
  items,
  onChange,
  template,
  renderFields,
  title = "Einträge",
  editing = false,          // NEW: control UI by edit mode
}) {
  const [list, setList] = useState(items || []);

  useEffect(() => { setList(items || []); }, [items]);

  const update = (next) => { setList(next); onChange(next); };
  // NEW: add at TOP
  const add = () => update([structuredClone(template), ...(list || [])]);
  const remove = (idx) => update(list.filter((_, i) => i !== idx));
  const setItem = (idx, patch) => update(list.map((it, i) => i === idx ? { ...it, ...patch } : it));

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <strong>{title}</strong>

        {/* show "+" only in editing mode */}
        {editing && (
          <button type="button" className="btn btn-sm btn-edit" onClick={add}>
            <i className="lni-plus me-1" aria-hidden="true"></i>
          </button>
        )}
      </div>

      {(list || []).map((it, idx) => (
        <div key={idx} className="border rounded p-3 mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong>#{idx + 1}</strong>

            {/* show remove only in editing mode */}
            {editing && (
              <button
                type="button"
                className="icon-btn icon-btn-danger"
                onClick={() => remove(idx)}
                aria-label={`Eintrag ${idx + 1} entfernen`}
                title="Entfernen"
              >
                <i className="lni-trash" aria-hidden="true"></i>
              </button>
            )}
          </div>

          {renderFields(it, (patch) => setItem(idx, patch))}
        </div>
      ))}
    </div>
  );
}
